<script setup>
import JetLabel from "@/Components/InputLabel.vue";
import FormInput from "@/Components/FormInput.vue";
import JetCheckbox from "@/Components/Checkbox.vue";
import JetInput from "@/Components/TextInput.vue";

import InputError from "@/Components/InputError.vue";

import { inject } from "vue";

const parentProps = inject("myProps");

const statusOptions = [
    { id: "pending", name: "Pending" },
    { id: "tester", name: "Tester" },
    { id: "accepted", name: "Accepted" },
    { id: "rejected", name: "Rejected" },
];
</script>

<template>
    <div class="mt-4 w-full sm:w-3/4">
        <div class="mb-8 border-b text-lg"><strong>General info</strong></div>

        <div v-if="!(parentProps.can.view_sensitive_event && parentProps.modal.type !== 'create')">
            Entrant account name: <strong>{{ $page.props.user.name }}</strong> <br />
            <div class="flex items-center">Email: {{ $page.props.user.email }}</div>
        </div>

        <div
            v-else
            class="mt-4 w-full rounded-lg border border-orange-200 bg-orange-50 p-4 text-gray-700 shadow"
        >
            <div
                class=""
                :title="`uid=${parentProps.form.user.id}`"
            >
                Entrant account name: <strong>{{ parentProps.form.user.name }}</strong>
            </div>

            <div v-if="parentProps.can.view_sensitive_event && parentProps.modal.type !== 'create'">
                <div class="flex items-center">Email: {{ parentProps.form.user.email }}</div>
                <div v-if="parentProps.form.user.gender">Gender: {{ parentProps.form.user.gender }}</div>
            </div>

            <div
                v-if="parentProps.can.view_sensitive_event && parentProps.modal.type !== 'create'"
                class=""
            >
                <JetLabel
                    for="is_entry_fee_paid"
                    class="p-5 pl-0"
                >
                    <div class="flex items-center">
                        <JetCheckbox
                            id="is_entry_fee_paid"
                            v-model:checked="parentProps.form.is_entry_fee_paid"
                            name="is_entry_fee_paid"
                        />
                        <div class="ml-2">Is entry fee paid?</div>
                    </div>
                </JetLabel>
            </div>

            <div v-if="parentProps.can.view_sensitive_event && parentProps.modal.type !== 'create'">
                <div class="">
                    <FormInput
                        v-model="parentProps.form.status"
                        type="select"
                        :options="statusOptions"
                        :error="
                            Object.hasOwn(parentProps.form.errors, 'status')
                                ? parentProps.form.errors['status']
                                : null
                        "
                        label="Status"
                        tooltip="What do competitor statuses mean?"
                        tooltip-href="/faq/what-do-competitor-statuses-mean-23"
                    ></FormInput>
                </div>

                <div class="mt-4 w-full sm:w-3/4">
                    <FormInput
                        v-model="parentProps.form.competitor_number"
                        type="text"
                        :error="
                            Object.hasOwn(parentProps.form.errors, 'competitor_number')
                                ? parentProps.form.errors['competitor_number']
                                : null
                        "
                        label="Competitor number"
                    ></FormInput>
                </div>
            </div>
        </div>

        <div class="mt-8">
            <FormInput
                v-model="parentProps.form.event_class_id"
                type="select"
                :options="parentProps.event.classes"
                :error="
                    Object.hasOwn(parentProps.form.errors, 'event_class_id')
                        ? parentProps.form.errors['event_class_id']
                        : null
                "
                label="Select event class *"
            ></FormInput>
        </div>

        <div class="mt-4">
            <FormInput
                v-model="parentProps.form.general.team_name"
                type="text"
                :error="
                    Object.hasOwn(parentProps.form.errors, 'general.team_name')
                        ? parentProps.form.errors['general.team_name']
                        : null
                "
                label="Team name (optional)"
            ></FormInput>
        </div>

        <div
            v-if="parentProps.event.hashid === 'K9V62' || parentProps.event.hashid === 'GZN44'"
            class="mt-4 w-full rounded-lg border border-gray-200 bg-gray-100 p-4 pt-0 shadow"
        >
            <!--                    <div class="mt-4">
                <JetLabel
                    for="meal"
                    class="p-0"
                    value="Do you want a meal? (Dinner €12, breakfast €6)"
                ></JetLabel>
                <div class="flex items-center">
                    <JetCheckbox
                        id="meal"
                        v-model:checked="parentProps.form.meal_1"
                    />
                    <div class="ml-2">No thanks</div>
                </div>
                <div class="flex items-center">
                    <JetCheckbox
                        id="meal"
                        v-model:checked="parentProps.form.meal_2"
                    />
                    <div class="ml-2">Saturday morning</div>
                </div>
                <div class="flex items-center">
                    <JetCheckbox
                        id="meal"
                        v-model:checked="parentProps.form.meal_3"
                    />
                    <div class="ml-2">Saturday night</div>
                </div>
                <div class="flex items-center">
                    <JetCheckbox
                        id="meal"
                        v-model:checked="parentProps.form.meal_4"
                    />
                    <div class="ml-2">Sunday morning</div>
                </div>
            </div>-->

            <!--                <div class="mt-4">
            <jet-label
                for="room"
                html-value="Choose room (+35 EUR) if needed and available (<a href='https://docs.google.com/spreadsheets/d/1UCiyDDtP0wVFqcMCITfQbfn9oLQBF2_jG9yHG0qjnas/edit#gid=0' target='_blank' class='cursor-pointer'>check availability here</a>)"
            />
            <select
                id="room"
                ref="room"
                v-model="parentProps.form.room"
                name="room"
                class="mt-1 block w-3/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            >
                <option value="-">-</option>
                <option value="1">room number 1</option>
                <option value="2">room number 2</option>
                <option value="3">room number 3</option>
                <option value="4">room number 4</option>
                <option value="5">room number 5</option>
                <option value="6">room number 6</option>
                <option value="7">room number 7</option>
                <option value="8">room number 8</option>
            </select>
        </div>-->

            <!--            <div class="mt-4">
                <jet-label
                    for="t_shirt"
                    value="Choose a DRIVER t-shirt"
                />
                <a
                    href="/img/alakonnu2023/shirt.jpg"
                    target="_blank"
                    class="mt-1 block w-2/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <img src="/img/alakonnu2023/shirt.jpg" />
                </a>
                <a
                    href="/img/alakonnu2023/info.jpg"
                    target="_blank"
                    class="mt-1 block w-2/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <img src="/img/alakonnu2023/info.jpg" />
                </a>
                <select
                    id="t_shirt_driver"
                    ref="t_shirt_driver"
                    v-model="parentProps.form.custom.t_shirt_driver"
                    name="t_shirt_driver"
                    class="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <option value="-">-</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                    <option value="XXL">XXL</option>
                </select>
            </div>

            <div class="mt-4">
                <jet-label
                    for="t_shirt_co_driver"
                    value="Choose a CO-DRIVER t-shirt"
                />
                <a
                    href="/img/alakonnu2023/shirt.jpg"
                    target="_blank"
                    class="mt-1 block w-2/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <img src="/img/alakonnu2023/shirt.jpg" />
                </a>
                <a
                    href="/img/alakonnu2023/info.jpg"
                    target="_blank"
                    class="mt-1 block w-2/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <img src="/img/alakonnu2023/info.jpg" />
                </a>
                <select
                    id="t_shirt_co_driver"
                    ref="t_shirt_co_driver"
                    v-model="parentProps.form.custom.t_shirt_co_driver"
                    name="t_shirt_co_driver"
                    class="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                >
                    <option value="-">-</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                    <option value="XXL">XXL</option>
                </select>
            </div>-->

            <div class="ml-0 mt-4">
                <p class="text-gray-700">
                    Early birds (registering until 14.09) get custom names printed on their motorcycle number
                    stickers.
                </p>
                <jet-label
                    for="number_sticker_label"
                    value="Enter yours here:"
                />
                <jet-input
                    id="number_sticker_label"
                    v-model="parentProps.form.custom.number_sticker_label"
                    type="text"
                    class="mt-1 block w-3/4"
                    placeholder=""
                />
            </div>

            <!--        <div
                        v-if="parentProps.form.t_shirt !== '-'"
                        class="ml-8 mt-4"
                    >
                        <jet-label
                            for="t_shirt_nr"
                            value="Number to print on the t-shirt"
                        />
                        <jet-input
                            id="t_shirt_nr"
                            v-model="parentProps.form.t_shirt_nr"
                            type="text"
                            class="mt-1 block w-3/4"
                            placeholder=""
                        />
                    </div>-->

            <!--                <div class="mt-4">
            <jet-label
                for="pullover"
                value="Choose pullover (+65 EUR)"
            />
            <select
                id="pullover"
                ref="pullover"
                v-model="parentProps.form.pullover"
                name="pullover"
                class="mt-1 block w-3/4 rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            >
                <option value="-">-</option>
                <option value="Male XS">Male XS</option>
                <option value="Female XS">Female XS</option>
                <option value="Male Size">Male Size</option>
                <option value="Female Size">Female Size</option>
                <option value="Male M">Male M</option>
                <option value="Female M">Female M</option>
                <option value="Male L">Male L</option>
                <option value="Female L">Female L</option>
                <option value="Male XL">Male XL</option>
                <option value="Female XL">Female XL</option>
                <option value="Male 2XL">Male 2XL</option>
                <option value="Female 2XL">Female 2XL</option>
                <option value="Male 3XL">Male 3XL</option>
                <option value="Female 3XL">Female 3XL</option>
                <option value="Male 4XL">Male 4XL</option>
                <option value="Male 5XL">Male 5XL</option>
            </select>
        </div>-->
        </div>

        <div class="mt-4">
            <FormInput
                v-model="parentProps.form.general.comment_to_organizer"
                type="textarea"
                label="Questions, suggestions, comments or invoice details to the organizer"
                rows="3"
                :error="
                    Object.hasOwn(parentProps.form.errors, 'general.comment_to_organizer')
                        ? parentProps.form.errors['general.comment_to_organizer']
                        : null
                "
            />
        </div>
    </div>
</template>
